import { AuthActions } from "../LoginRedux/Action";
import { pickerDashboardActions } from "./action";

const initialState = {
  pickerDashboardDataSuccess: null,
  pickerDashboardDataError: null,
  pickerStatsDataSuccess: null,
  pickerStatsDataError: null,
};

export const pickerstatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case pickerDashboardActions.FETCH_PICKER_DASHBOARDDATA_SUCCESS:
      return {
        ...state,
        pickerStatsDataSuccess: action.payload,
        pickerStatsDataError: null,
      };

    case pickerDashboardActions.FETCH_PICKER_DASHBOARDDATA_FAILURE:
      return {
        ...state,
        pickerStatsDataSuccess: null,
        pickerStatsDataError: action.payload,
      };

    case pickerDashboardActions.FETCH_PICKER_DASHBOARD_SUCCESS:
      return {
        ...state,
        pickerDashboardDataSuccess: action.payload,
        pickerDashboardDataError: null,
      };

    case pickerDashboardActions.FETCH_PICKER_DASHBOARD_FAILURE:
      return {
        ...state,
        pickerDashboardDataSuccess: null,
        pickerDashboardDataError: action.payload,
      };

    default:
      return state;
  }
};
